import { Device } from "@capacitor/device";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { getAPIClient } from "./apiClient";
import { errorLog } from "./utils/logger";
import Bugsnag from "@bugsnag/js";
import { updateDevicesAtom } from "./jotai/atomUpdater";

export const registerPushPermission = async () => {
  if (!Capacitor.isNativePlatform()) return;
  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === "prompt") {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive === "granted") {
    await PushNotifications.register();
  }

  return permStatus.receive === "granted";
};

export const initializePushNotificationListeners = async () => {
  if (!Capacitor.isNativePlatform()) return;

  await PushNotifications.addListener("registration", (token) => {
    // Need to explicitly tell Typescript that we are not handling the returned promise
    // since the event listener expects a synchronous function
    void (async () => {
      try {
        const device = await Device.getInfo();
        const apiClient = getAPIClient();
        const devices = await apiClient.getDevices();
        const existingDevice = devices.find((device) => device.device_id === token.value);

        if (!existingDevice) {
          // Trying to stay consistent with the device name in the backend
          const deviceName = Capacitor.getPlatform() === "ios" ? "iPhone Device" : "Android Device";
          await apiClient.createDevice({
            device_id: token.value.toLowerCase(),
            name: deviceName,
            platform: device.platform,
          });
        }
        await updateDevicesAtom();
      } catch (error) {
        errorLog(error as Error);
        Bugsnag.notify(error as Error);
      }
    })();
  });

  await PushNotifications.addListener("registrationError", (error) => {
    errorLog(new Error(error.error));
    Bugsnag.notify(new Error(error.error));
  });
};
